import type { Vector3 } from '@canvas/vector';

import { ghostConnectorPreview, n300, y250 } from '../colors';

import {
  miscellaneousColorMap,
  elementColorMap,
  textColorMap,
  iconColorMap,
  backgroundColorMap,
} from './color-maps';
import {
  allPathColourPalette,
  paletteColourMapping,
  backgroundColourPaletteSwatch,
  stickyAccentColourMapping,
  allDefaultColourPalette,
} from './palettes';

// Convert our palette configurations into maps for consumption downstream
export const allPathColorMap: Record<string, Vector3> = {
  ...allPathColourPalette.reduce((acc, key) => {
    return {
      ...acc,
      ...paletteColourMapping[key],
    };
  }, {}),
  ...{ ghostConnectorPreview },
};

export interface ColorEntry {
  background: Vector3;
  accent: string;
}

/**
 * With the new Content Wrapper sticky changes, each sticky has a background color and an
 * accent color (color for the stroke and fold of the sticky icon in the main toolbar)
 */
export const allStickyColorMap = backgroundColourPaletteSwatch.reduce(
  (acc: Record<string, ColorEntry>, backgroundKey) => {
    const backgroundColours = paletteColourMapping[backgroundKey];
    const accentColours = stickyAccentColourMapping[backgroundKey];

    // Iterate over background colors and map them with accent colors by index
    if (backgroundColours && accentColours) {
      Object.entries(backgroundColours).forEach(
        ([mainColorKey, mainColorValue], index) => {
          const accentColorValue = Object.values(accentColours)[index];
          acc[mainColorKey] = {
            background: mainColorValue,
            accent: accentColorValue ?? mainColorValue,
          };
        }
      );
    }
    return acc;
  },
  {} as Record<string, ColorEntry>
);

export const allDefaultColorMap: Record<string, Vector3> = allDefaultColourPalette.reduce(
  (acc, key) => {
    return {
      ...acc,
      ...paletteColourMapping[key],
    };
  },
  {}
);

export const allColorMap = {
  n300,
  y250, // Old yellow color, for backwards compatibility
  ...miscellaneousColorMap,
  ...elementColorMap,
};

export const allTextColorMap = {
  ...textColorMap,
  ...iconColorMap,
  ...backgroundColorMap,
};
